'use client';

export { default, createFilterOptions } from './useAutocomplete';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/useAutocomplete/index.js
// module id = 885
// module chunks = 25